import jwt, { JwtPayload } from 'jsonwebtoken';

import { AccountStatus } from '@/shared/api';
import { TenantOwner } from '@/shared/store/auth.store';

export type AccessTokenPayload = JwtPayload & {
  profileId: number;
  status: AccountStatus;
  tenantOwners?: TenantOwner[];
  sessionId: string;
  cnf?: { jkt: string };
};

export const extractTokenPayload = <T extends JwtPayload>(token: string): T => {
  const jwtData = jwt.decode(token) as T;
  return jwtData;
};
